import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, useTheme } from "@material-ui/core";
import { observer } from "mobx-react";
import { localize } from "../../../../../common/libs";
import { SnackbarType } from "../../../../../stores/common";
import { useStores } from "../../../../../hooks";
import { ModifiersFormType } from "../../../store/modifiersSets/forms";
import { IDeleteMenuItemModifierSetRequest } from "../../../../../services/menu/requestsResponses";
import { useHistory } from "react-router-dom";
import {useTranslation} from "react-i18next";


const DeleteModifiersSetForm = () => {
    const {t} = useTranslation(["general", "menu"]);
    const { modifiersSetsStore, generalStore } = useStores();
    const forms = modifiersSetsStore.forms;
    const { open, current } = forms.forms[ModifiersFormType.deleteMenuModifiersSet];
    const history = useHistory();
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    if (!current) return null;

    const submitDelete = async (e: React.MouseEvent) => {

        e.preventDefault();
        e.stopPropagation();

        const data: IDeleteMenuItemModifierSetRequest = {
            menuItemModifierSetId: current.id,
        };
        const deletedModifier = await modifiersSetsStore.removeModifiersSet(data);
        if (!deletedModifier) {
            const params: ({ type: SnackbarType, title: string, description?: string }) = {
                title: t("general:somethingWentWrong"),
                type: SnackbarType.error,
                description: t("general:tryAgain")
            }
            generalStore.showSnackbar(params);

        } else {
            generalStore.showSuccessSnackbar(t("menu:modifiersSet.modifiersSetDeleted"));
            modifiersSetsStore.forms.closeForm(ModifiersFormType.deleteMenuModifiersSet);
            history.push(`/menus/modifiers/list`);
        }
    }


    return (
        <Dialog
            open={open}
            onClose={() => {
                modifiersSetsStore.forms.closeForm(ModifiersFormType.deleteMenuModifiersSet)
            }
            }
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title">
                {t("menu:modifiersSet.deleteModifiersSet")}
            </DialogTitle>
            <DialogContent>
                {t("menu:modifiersSet.youGoingRemoveModifiersSets")} '{localize(current.data.name)}'.
                <br/>
                {t("menu:modifiersSet.thisModifiersSetWillDeletedFromPositions")}

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        modifiersSetsStore.forms.closeForm(ModifiersFormType.deleteMenuModifiersSet)
                    }}
                    color="primary">
                    {t("general:cancel")}
                </Button>
                <Button
                    color="default"
                    onClick={submitDelete}
                >
                    {t("menu:modifiersSet.wantDelete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default observer(DeleteModifiersSetForm);


